import { render, staticRenderFns } from "./Referencias.vue?vue&type=template&id=2572cfbf"
import script from "./Referencias.vue?vue&type=script&lang=js"
export * from "./Referencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports